module.exports = __webpack_public_path__ + "static/media/terraforming-mars-icons.06ac25f4.png";